/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { cn } from '@/lib/utils';
import React, { useState } from 'react';
import Lightbox from 'react-18-image-lightbox';

import ImageComponent from './ImageComponent';

// import getTeamsUrl from '../../../utils/getTeamsUrl';

const AttachmentGallery = ({ attachments, isSentByAuthUser, message }) => {
	// eslint-disable-next-line no-unused-vars
	const [isLightboxOpen, setIsLightboxOpen] = useState(false);
	const [imageBlobs, setImageBlobs] = useState([]);
	const [photoIndex, setPhotoIndex] = useState(0);

	const saveImage = (imageBlob) => {
		setImageBlobs((prevImageBlobs) => [...prevImageBlobs, imageBlob]);
	};

	const openLightbox = (index) => {
		setPhotoIndex(index);
		setIsLightboxOpen(true);
	};

	return (
		<div
			style={{
				marginTop: 4,
				justifyContent: isSentByAuthUser ? 'flex-end' : 'flex-start',
			}}
		>
			<div
				className={cn(
					isSentByAuthUser ? 'flex-row-reverse' : '',
					' flex h-full flex-wrap space-y-1 items-end'
				)}
				style={{
					width: '100%',
					marginRight: '2px',
				}}
			>
				{attachments.map((item, index) => (
					<div
						className={cn('h-full flex mx-0.5')}
						key={item.url}
						style={{
							maxWidth: '250px',
						}}
					>
						<ImageComponent
							name={item.name}
							src={item.url}
							item={item}
							onImageLoad={saveImage}
							openLightbox={() => openLightbox(index)}
							isInMessageContainer
							message={message}
						/>
					</div>
				))}
			</div>

			{isLightboxOpen && (
				<Lightbox
					mainSrc={imageBlobs[photoIndex]}
					nextSrc={imageBlobs[(photoIndex + 1) % imageBlobs.length]}
					prevSrc={
						imageBlobs[
							(photoIndex + imageBlobs.length - 1) %
								imageBlobs.length
						]
					}
					onCloseRequest={() => setIsLightboxOpen(false)}
					reactModalStyle={{ zIndex: 99999 }}
					onMovePrevRequest={() =>
						setPhotoIndex(
							(photoIndex + imageBlobs.length - 1) %
								imageBlobs.length
						)
					}
					onMoveNextRequest={() =>
						setPhotoIndex(
							(photoIndex + imageBlobs.length + 1) %
								imageBlobs.length
						)
					}
				/>
			)}
		</div>
	);
};

export default AttachmentGallery;
